import React from "react";
import { Form } from "antd";

const FormItem = ({ children, className, value, ...rest }) => {
  return <Form.Item {...rest}>{children}</Form.Item>;
};

export default FormItem;
